import { render, staticRenderFns } from "./AppWebSettingsCreate.vue?vue&type=template&id=f2caf6b2"
import script from "./AppWebSettingsCreate.vue?vue&type=script&lang=js"
export * from "./AppWebSettingsCreate.vue?vue&type=script&lang=js"
import style0 from "./AppWebSettingsCreate.vue?vue&type=style&index=0&id=f2caf6b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports